import React from "react";
import styles from "./TravelBrandSection.module.css";
import travelimgs from "../../../Images/TravelBrand_img.png";

const TravelBrandSection = () => {

    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>
                Trusted by Leading Hotels & Travel Brands
            </h2>
            <p>
                See how AI is transforming customer experiences and operational <br />
                efficiency in hospitality.
            </p>
            <div className={styles.wrapper}>
                <div className={styles.featureList}>
                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Case studies with hotels, airlines, and tour operators</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Metrics like increased bookings, reduced <br />
                                support load</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Testimonials & reviews</h4>
                        </div>
                    </div>
                    <div className={styles.buttons}>
                        <button className={styles.primaryBtn} >View Case Studies</button>
                    </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className={styles.right}>
                    <img src={travelimgs} alt="travel cancellation" />
                </div>
            </div>
        </section>
    );
};

export default TravelBrandSection;
